import React from 'react';
import { formatInr } from '../lib/formatInr';

// "₹520 + ₹93.60 GST" (+ insurance when it changed) for a GST-inclusive difference.
export const GstSplitText = ({ split, className = '', testId }) => {
  if (!split || !Number(split.total)) return null;
  const parts = [`${formatInr(split.service)} + ${formatInr(split.gst)} GST`];
  if (Number(split.insurance) > 0) parts.push(`${formatInr(split.insurance)} insurance`);
  return (
    <span className={className} data-testid={testId}>
      ({parts.join(' + ')})
    </span>
  );
};
